export default {
  email: 'Email',
  password: 'Kata Sandi',
  repeatPassword: 'Ulang Kata Sandi',
  login: 'Masuk',
  activateAccount: 'Aktivasi Akun',
  username: 'Nama Lengkap'
}
